import { ButtonProps } from '../Button/Button';
import { DDGProps, DDGQuestion } from './DoctorDiscussionGuideTypes';

const ariaLabel = '';
const color: ButtonProps['color'] = 'cta-purple';
const extraClasses = '';
const href: ButtonProps['href'] = '#';
const target: ButtonProps['target'] = '_self';
const nsa: (ButtonProps & { id: number; extraClasses: string })[] = [
  { id: 0, label: 'NEVER', ariaLabel, color, target, href, extraClasses },
  { id: 1, label: 'SOMETIMES', ariaLabel, color, target, href, extraClasses },
  { id: 2, label: 'ALWAYS', ariaLabel, color, target, href, extraClasses }
];
const yn: (ButtonProps & { id: number; extraClasses: string })[] = [
  { id: 0, label: 'YES', ariaLabel, color, target, href, extraClasses },
  { id: 1, label: 'NO', ariaLabel, color, target, href, extraClasses }
];
const ynm: (ButtonProps & { id: number; extraClasses: string })[] = [
  { id: 0, label: 'YES', ariaLabel, color, target, href, extraClasses },
  { id: 1, label: 'NO', ariaLabel, color, target, href, extraClasses },
  { id: 2, label: 'MAYBE', ariaLabel, color, target, href, extraClasses }
];
export const DDGQuestionsUF: DDGQuestion[] = [
  {
    question:
      'My period is heavy, and I am using double protection (like a tampon and pad) to prevent leaking',
    answers: nsa,
    multiselect: false
  },
  {
    question:
      'When I leave the house, I pack a change of clothes in case of leaks',
    answers: nsa,
    multiselect: false
  },
  {
    question: 'I have to change my pads/tampons hourly',
    answers: nsa,
    multiselect: false
  },
  {
    question:
      'When I’m on my period, I find myself limiting or canceling my plans due to heavy period bleeding',
    answers: nsa,
    multiselect: false
  },
  {
    question: 'I often feel tired or dizzy from heavy period bleeding',
    answers: nsa,
    multiselect: false
  },
  {
    question: 'My period lasts more than 7 days',
    answers: yn,
    multiselect: false
  },
  {
    question:
      'I would be interested in taking a once-daily medication for heavy periods from uterine fibroids',
    answers: ynm,
    multiselect: false
  },
  {
    question: 'Thank you for your responses!',
    answers: ynm,
    multiselect: false
  }
];

export const DDGUF: DDGProps = {
  filename: 'UF Conversation Guide',
  bgColor: 'purple-010',
  color: 'purple-100',
  type: 'UF',
  questions: DDGQuestionsUF
};
